<!-- @Version: 1.0.6 -->
@if (done$$() == true) {
   <div data-testid="numberInputContainer" [formGroup]="fgNumber" class="row">
      <mat-form-field data-width="100%" [hideRequiredMarker]="hideRequireMaker" >
         @if (fieldItem.attribute_1 && fieldItem.attribute_1 != '') {
            <mat-label data-testid="label" [innerHTML]="fieldItem.attribute_1!"></mat-label>
         }
         <input data-testid="input" [formControlName]="FC_NUMBER.NUMBER" matInput [required]="fieldItem.required! && !fgNumber.get(FC_NUMBER.NUMBER)?.disabled"  [placeholder]="fieldItem.placeholder ?? ''">
         <span matSuffix></span>
         @if (fgNumber.get(FC_NUMBER.NUMBER)?.hasError(VALIDATORS.pattern)) {
            <mat-error data-testid="errorPattern" [innerHTML]="error.errorCodePattern"></mat-error>
         }
         @else if (fgNumber.get(FC_NUMBER.NUMBER)?.hasError(VALIDATORS.positiv)) {
            <mat-error data-testid="errorPos" [innerHTML]="error.errorCodePos"></mat-error>
         }
         @else if (fgNumber.get(FC_NUMBER.NUMBER)?.hasError(VALIDATORS.negativ)) {
            <mat-error data-testid="errorNeg" [innerHTML]="error.errorCodeNeg"></mat-error>
         }
         @else if (fgNumber.get(FC_NUMBER.NUMBER)?.hasError(VALIDATORS.range)) {
            <mat-error data-testid="errorRange" [innerHTML]="error.errorCodeRange"></mat-error>
         }
         @else if (fgNumber.get(FC_NUMBER.NUMBER)?.hasError(VALIDATORS.minnumber)) {
            <mat-error data-testid="errorMin" [innerHTML]="error.errorCodeMin"></mat-error>
         }
         @else if (fgNumber.get(FC_NUMBER.NUMBER)?.hasError(VALIDATORS.maxnumber)) {
            <mat-error data-testid="errorMax" [innerHTML]="error.errorCodeMax"></mat-error>
         }
         @else if (fgNumber.get(FC_NUMBER.NUMBER)?.hasError(VALIDATORS.decimal)) {
            <mat-error data-testid="errorDecimal" [innerHTML]="error.errorCodeDecimal"></mat-error>
         }
         @else if (fgNumber.get(FC_NUMBER.NUMBER)?.hasError(VALIDATORS.required) && fgNumber.get(FC_NUMBER.NUMBER)?.touched ) {
            <mat-error data-testid="errorRequired" [innerHTML]="error.errorCodeRequired"></mat-error>
         }
        
      </mat-form-field>
   </div>
}
